import { storyblokEditable } from '@storyblok/react';
import { FC } from 'react';
import { BrandCategoryBannerStoryblok } from 'storyblok-types';
import { Image } from 'atoms/Image/Image';
import { H1 } from 'atoms/Typography';
import { IStoryBlokComponentProps } from 'pages/StoryBlok/types';
import styles from './styles.module.css';

export const BrandCategoryBanner: FC<
  IStoryBlokComponentProps<BrandCategoryBannerStoryblok>
> = ({ blok }) => {
  return (
    <>
      <H1
        className={styles.heading}
        style={{ background: blok.headline_background_color?.color }}
      >
        {blok.headline}
      </H1>
      <div className={styles.root} {...storyblokEditable(blok)}>
        <Image
          className={styles.hero}
          src={blok.hero?.filename}
          alt={blok.hero?.alt}
        />
        <Image
          className={styles.logo}
          src={blok.logo?.filename}
          alt={blok.logo?.alt}
        />
      </div>
    </>
  );
};
